import React from "react";

const EventErrorImage = ({ type }: { type: EventErrorType }) => {
  if (type === "mismatch") {
    return (
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 538 203"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="64" y="24.7421" width="410.218" height="131.27" rx="16.4087" fill="#F1F1F1" />
        <rect x="96.8174" y="49.3552" width="188.7" height="31.1766" rx="8.20436" fill="#D6D6D6" />
        <rect x="96.5345" y="90.3345" width="82.0436" height="31.12" rx="8.20436" fill="#D6D6D6" />
        <rect x="312.96" y="91.749" width="96.1891" height="96.1891" rx="48.0945" fill="#D6D6D6" />

        <mask
          id="mask0_716_55"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="337"
          y="115"
          width="49"
          height="49"
        >
          <rect x="337.007" y="115.796" width="48.0945" height="48.0945" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_716_55)">
          <path
            d="M375.282 159.632L369.221 153.621C369.02 153.788 368.795 153.929 368.545 154.046C368.294 154.163 368.052 154.272 367.818 154.372C367.183 154.673 366.565 154.665 365.964 154.348C365.363 154.03 365.062 153.387 365.062 152.418C365.062 152.051 365.171 151.708 365.389 151.39C365.605 151.074 365.897 150.832 366.265 150.665L350.233 134.633C349.866 135.468 349.573 136.329 349.356 137.214C349.139 138.099 349.031 139.009 349.031 139.944C349.031 141.447 349.315 142.908 349.883 144.326C350.45 145.747 351.335 147.058 352.538 148.26L353.039 148.761V145.855C353.039 145.288 353.231 144.811 353.616 144.427C353.999 144.043 354.475 143.851 355.043 143.851C355.61 143.851 356.087 144.043 356.472 144.427C356.855 144.811 357.047 145.288 357.047 145.855V153.871C357.047 154.439 356.855 154.915 356.472 155.298C356.087 155.683 355.61 155.875 355.043 155.875H347.027C346.459 155.875 345.983 155.683 345.598 155.298C345.215 154.915 345.023 154.439 345.023 153.871C345.023 153.303 345.215 152.828 345.598 152.444C345.983 152.06 346.459 151.867 347.027 151.867H350.534L349.732 151.166C348.096 149.529 346.901 147.751 346.149 145.831C345.398 143.91 345.023 141.948 345.023 139.944C345.023 138.441 345.215 136.996 345.598 135.609C345.983 134.224 346.543 132.913 347.277 131.678L341.216 125.616C340.848 125.248 340.664 124.781 340.664 124.213C340.664 123.645 340.865 123.161 341.266 122.76C341.633 122.393 342.101 122.209 342.668 122.209C343.236 122.209 343.72 122.393 344.121 122.76L378.138 156.827C378.505 157.194 378.689 157.662 378.689 158.23C378.689 158.798 378.505 159.265 378.138 159.632C377.737 160.033 377.253 160.234 376.685 160.234C376.117 160.234 375.65 160.033 375.282 159.632ZM374.932 147.909L371.926 144.904C372.293 144.102 372.577 143.267 372.778 142.399C372.978 141.53 373.078 140.645 373.078 139.743C373.078 138.24 372.794 136.779 372.226 135.359C371.659 133.94 370.774 132.629 369.571 131.427L369.07 130.926V133.832C369.07 134.4 368.879 134.875 368.495 135.259C368.11 135.643 367.634 135.836 367.066 135.836C366.499 135.836 366.023 135.643 365.64 135.259C365.255 134.875 365.062 134.4 365.062 133.832V125.816C365.062 125.248 365.255 124.772 365.64 124.387C366.023 124.004 366.499 123.812 367.066 123.812H375.082C375.65 123.812 376.125 124.004 376.509 124.387C376.894 124.772 377.086 125.248 377.086 125.816C377.086 126.384 376.894 126.86 376.509 127.245C376.125 127.628 375.65 127.82 375.082 127.82H371.575L372.377 128.521C374.013 130.158 375.208 131.936 375.96 133.856C376.711 135.777 377.086 137.739 377.086 139.743C377.086 141.246 376.894 142.674 376.509 144.026C376.125 145.379 375.6 146.674 374.932 147.909ZM355.995 128.972L352.989 125.966C353.156 125.866 353.364 125.749 353.614 125.616C353.865 125.482 354.091 125.382 354.291 125.315C354.959 125.014 355.585 125.039 356.169 125.389C356.754 125.741 357.047 126.367 357.047 127.269C357.047 127.636 356.955 127.962 356.772 128.247C356.588 128.53 356.329 128.772 355.995 128.972Z"
            fill="#454545"
          />
        </g>
        <rect
          x="312.96"
          y="91.749"
          width="96.1891"
          height="96.1891"
          rx="48.0945"
          stroke="#D6D6D6"
        />
      </svg>
    );
  }

  if (type === "missing") {
    return (
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 538 203"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="64" y="24.7421" width="410.218" height="131.27" rx="16.4087" fill="#F1F1F1" />
        <rect x="96.8174" y="49.3552" width="188.7" height="31.1766" rx="8.20436" fill="#D6D6D6" />
        <rect x="96.5347" y="90.3345" width="82.0436" height="31.12" rx="8.20436" fill="#D6D6D6" />
        <rect x="313" y="92" width="96" height="96" rx="48" fill="#D6D6D6" />
        <path
          d="M356.852 144.861C356.852 143.576 357.087 142.464 357.557 141.524C358.058 140.553 358.638 139.769 359.296 139.174C359.985 138.547 360.878 137.827 361.975 137.012C363.259 136.072 364.199 135.273 364.795 134.615C365.39 133.926 365.688 133.095 365.688 132.124C365.688 130.965 365.249 130.009 364.372 129.257C363.526 128.505 362.382 128.129 360.941 128.129C359.249 128.129 357.87 128.646 356.805 129.68C355.771 130.714 355.238 132.14 355.207 133.957H348.392C348.58 131.544 349.222 129.476 350.319 127.753C351.447 125.998 352.919 124.667 354.737 123.758C356.585 122.818 358.669 122.348 360.988 122.348C363.244 122.348 365.202 122.771 366.863 123.617C368.555 124.463 369.855 125.622 370.764 127.095C371.672 128.536 372.127 130.134 372.127 131.889C372.127 133.205 371.876 134.349 371.375 135.32C370.905 136.291 370.325 137.106 369.636 137.764C368.946 138.391 368.053 139.096 366.957 139.879C365.672 140.85 364.732 141.681 364.137 142.37C363.541 143.028 363.244 143.858 363.244 144.861V146.741H356.852V144.861ZM360.048 156.705C358.951 156.705 358.027 156.329 357.275 155.577C356.523 154.794 356.147 153.854 356.147 152.757C356.147 151.629 356.523 150.689 357.275 149.937C358.027 149.185 358.951 148.809 360.048 148.809C361.176 148.809 362.116 149.185 362.868 149.937C363.62 150.689 363.996 151.629 363.996 152.757C363.996 153.854 363.62 154.794 362.868 155.577C362.116 156.329 361.176 156.705 360.048 156.705Z"
          fill="#454545"
        />
        <rect x="313" y="92" width="96" height="96" rx="48" stroke="#D6D6D6" />
      </svg>
    );
  }

  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 538 203"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="64" y="24.7421" width="410.218" height="131.27" rx="16.4087" fill="#F1F1F1" />
      <rect x="96.8174" y="49.3552" width="188.7" height="31.1766" rx="8.20436" fill="#D6D6D6" />
      <rect x="96.5345" y="90.3345" width="82.0436" height="31.12" rx="8.20436" fill="#D6D6D6" />
    </svg>
  );
};

type EventErrorType = "missing" | "mismatch" | "generic";
export type EventRenderingErrorProps = {
  type: EventErrorType;
};

export const EventRenderingError = ({ type }: EventRenderingErrorProps) => {
  let errorTitle = "Unable to load event";
  let errorDescription =
    "An error occurred while trying to load this event. Please try viewing this event again later.";

  if (type === "missing") {
    errorTitle = "Event not found";
    errorDescription =
      "We can't view this event because it may have been cancelled or removed from your calendar.";
  } else if (type === "mismatch") {
    errorTitle = "Event not synced";
    errorDescription =
      "We can't view this event because it's on a calendar that Clockwise doesn't have access to.";
  }

  return (
    <div className="cw-flex cw-flex-col cw-items-center cw-max-w-md cw-h-full cw-m-auto cw-px-6 cw-py-3">
      <p className="cw-heading-xl">{errorTitle}</p>
      <div className="cw-my-2">
        <EventErrorImage type={type} />
      </div>
      <div className="cw-text-center cw-body-base cw-text-accent">{errorDescription}</div>
    </div>
  );
};
